/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateFeedbackRequest } from '../../models/create-feedback-request';
import { Feedback } from '../../models/feedback';

export interface CreateFeedback$Params {
      body: CreateFeedbackRequest
}

export function createFeedback(http: HttpClient, rootUrl: string, params: CreateFeedback$Params, context?: HttpContext): Observable<StrictHttpResponse<Feedback>> {
  const rb = new RequestBuilder(rootUrl, createFeedback.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Feedback>;
    })
  );
}

createFeedback.PATH = '/v0/feedbacks';
